import { Typography, Button } from "@/design-system/Atoms";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/routes/routes.config";
import { usePatientCTAButtonConfig } from "@/hooks/usePatientCTAButtonConfig";

interface ImageCtaCardProps {
  heading?: string;
  description?: string;
  buttonText?: { text: string; to?: string; afterUpdateProfileText?: string };
  midCta?: boolean;
}

const ImageCtaCard: FC<ImageCtaCardProps> = ({
  heading,
  description,
  buttonText,
  midCta,
}) => {
  const navigate = useNavigate();
  const isAuthenticated = false;
  const { ctaButtonConfig, patientEntitlementsIsLoading } =
    usePatientCTAButtonConfig(buttonText?.text);
  const isLearnMore = buttonText?.text === "Learn More";
  const isGetStarted = buttonText?.text === "Get Started";

  const handleClick = () => {
    if (isLearnMore) {
      if (!buttonText?.to) {
        navigate(ROUTES.QUESTIONNAIRES);
      } else {
        window.open(buttonText.to, "_blank");
      }
    } else if (isGetStarted) {
      ctaButtonConfig.action?.();
    }
  };

  const isLoading = isGetStarted ? patientEntitlementsIsLoading : false;
  let buttonLabel = ctaButtonConfig.text;

  if (isLearnMore) {
    const baseText = buttonText?.text ?? "";
    buttonLabel = isAuthenticated
      ? (buttonText?.afterUpdateProfileText ?? baseText)
      : baseText;
  }

  return (
    <div className={`w-full lg:w-1/2 ${midCta ? "ml-auto" : ""}`}>
      <div
        className={`text-white rounded-[20px] bg-white/5 backdrop-blur-[20px] ${midCta ? "" : "ms-0 lg:ms-8"}`}
      >
        <div className="grid-cols-2 p-6 md:p-8 gap-4 md:gap-5">
          <Typography variant="imageCardHeading" as="h2" className="mb-4">
            {heading}
          </Typography>
          <Typography variant="imageCardDescription" as="p">
            {description}
          </Typography>
          <Button
            variant="secondary"
            size="xl"
            className="w-full md:w-auto mt-[3.125rem]"
            onClick={handleClick}
            loading={isLoading}
          >
            {buttonLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ImageCtaCard;
